import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal } from '@angular/core';
import {
  ReleaseCalendarSelectedOptions,
  DayExpensesReleaseCalendar,
  ManagerReleaseCalendar
} from "../../types/release-calendar-types";
import { days } from "../../configs/release-calendar-config";
import { UtilityService } from "../../../../../core/services/utility.service";
import { ReleaseCalendarService } from "../../services/release-calendar.service";
import { smoothShowHideWidth } from "../../../../../shared/animations/smoothShowHideAnimations";
import { MatButton } from "@angular/material/button";

@Component({
  selector: 'app-release-calendar-manager',
  standalone: true,
  imports: [
    MatButton
  ],
  templateUrl: './release-calendar-manager.component.html',
  styleUrls: [
    './release-calendar-manager.component.scss',
    '../release-calendar-components.styles.scss'
  ],
  animations: [ smoothShowHideWidth ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReleaseCalendarManagerComponent implements OnInit {
  releaseCalendarManager = input.required<ManagerReleaseCalendar>();
  releaseCalendarSelectedOptions = input.required<ReleaseCalendarSelectedOptions>();
  releaseCalendarTeamExpenses = input.required<Array<DayExpensesReleaseCalendar>>();
  managerIndex = input.required<number>();

  private utilityService:UtilityService = inject(UtilityService);
  private releaseCalendarService: ReleaseCalendarService = inject(ReleaseCalendarService);

  protected readonly days = days;
  public totalDays = signal<Array<number>>([]);
  public isVisible = signal<boolean>(true);

  public ngOnInit(): void {
    this.totalDays.set(this.releaseCalendarService.generateDays(this.releaseCalendarSelectedOptions()));
    this.isVisible.set(!!this.releaseCalendarManager().monthCount);
  }

  public formatBudgetValue(value: number): string {
    return this.utilityService.formatBudgetValue({ value });
  }

  public isSameDay(releaseCalendarAdvertisements: DayExpensesReleaseCalendar, dayLabel: number): boolean {
    return releaseCalendarAdvertisements.plannedDate['2'] === dayLabel;
  }

  public hasDataForDay(day: number): boolean {
    if (day === 0) { return false; }

    return this.releaseCalendarManager().expenses.some(ad => this.isSameDay(ad, day));
  }

  public toggleVisibility(): void {
    this.isVisible.update(i => !i);
  }
}
